import React from "react";
import { styled } from "goober";
import { mobile } from "clutch/src/Style/style.mjs";

import { CONTENT_HEADER_Z_INDEX } from "@/app/constants.mjs";

export const OverflowContainer = styled("div", React.forwardRef)`
  position: relative;
  height: var(--sp-12_5);
  padding: var(--sp-1);
  width: 100%;
  overflow-x: scroll;
  scrollbar-width: none;
  /* allows room for accessibility outline */
  padding: var(--sp-1_5);
  margin: calc(-1 * var(--sp-1_5));
  &::-webkit-scrollbar {
    display: none;
  }
  &.hide-labels label {
    display: none;
  }
`;

export const TabsRow = styled("div", React.forwardRef)`
  position: absolute;
  display: flex;
  align-items: center;
  gap: var(--sp-2);
`;

export const TabButton = styled("div", React.forwardRef)<{
  $color?: string;
  $boxShadow?: string;
  $background?: string;
}>`
  /* base style is the "selected state" due to managing svg original fills */
  position: relative;
  display: flex;
  align-items: center;
  gap: var(--sp-2);
  padding: 0 var(--sp-3);
  height: var(--sp-10);
  border-radius: var(--br-lg);
  overflow: hidden;
  white-space: nowrap;

  background-color: var(--shade6);
  box-shadow: ${({ $boxShadow }) =>
    $boxShadow ?? "inset 0px 1px 0px var(--shade5)"};

  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  color: var(--shade0);
  letter-spacing: -0.009em;

  user-select: none;
  cursor: pointer;

  & > label {
    cursor: pointer;
  }

  & > svg {
    flex: 0 0 var(--sp-5);
    width: var(--sp-5);
    height: var(--sp-5);
  }

  &:not(.selected) {
    color: ${({ $color }) => $color ?? "var(--shade1-50)"};
    background-color: ${({ $background }) => $background ?? "var(--shade8-50)"};
    box-shadow: none;

    & > svg > .icon-box {
      fill: var(--shade1-50);
    }
  }

  &:focus:not(.selected),
  &:hover:not(.selected),
  &:active:not(.selected) {
    color: ${({ $color }) => $color ?? "var(--shade1)"};
    background-color: var(--shade7);

    & > svg {
      fill: var(--shade1);
    }

    & > svg > .icon-box {
      fill: var(--shade1);
    }
  }

  &.selected label {
    display: inline;
  }
  ${mobile} {
    &.selected label {
      display: none;
    }
  }
`;

export const DropdownMenu = styled("div", React.forwardRef)`
  z-index: ${CONTENT_HEADER_Z_INDEX + 2};
  position: absolute;
  min-width: 230px;

  display: flex;
  flex-direction: column;

  padding: var(--sp-2);

  white-space: nowrap;

  border-radius: var(--br);
  background: var(--shade10);
  box-shadow:
    0px 4px 12px rgba(7, 8, 12, 0.25),
    0px 12px 24px rgba(7, 8, 12, 0.25);

  & > span {
    font-size: 14px;
    color: var(--shade2);
    padding: var(--sp-3) var(--sp-3) var(--sp-2) var(--sp-3);
    user-select: none;
  }
`;

export const DropdownMenuItem = styled("div", React.forwardRef)`
  display: flex;
  align-items: center;
  gap: var(--sp-3);
  padding: var(--sp-2) var(--sp-3);
  border-radius: var(--br);
  user-select: none;
  cursor: pointer;

  &:hover {
    background: var(--shade8);
    box-shadow: inset 0px 1px 0px rgba(227, 229, 234, 0.25);
  }

  svg {
    fill: var(--shade2);
  }

  &:hover svg {
    fill: var(--shade1);
  }
`;
